<template>
  <div class="external-div">
    <router-view v-if="isShowInvoice"/>
  </div>
</template>

<script>
export default {
  name: 'AgentFrame',
  componentName: 'AgentFrame',

  computed: {
    isShowInvoice () {
      return this.$store.state.showInvoiceView
    },
  }
}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/pages/agent/agentFrame.vue